import './about.scss'

const AboutPage = () => (
  <article className="about-page">
    <header className="about-page__hero">
      <p className="about-page__eyebrow">About</p>
      <h1>John Behr, PhD</h1>
      <p className="about-page__identity">
        John Behr, PhD, industrial and organizational psychologist
      </p>
    </header>

    <section className="about-page__content" aria-labelledby="about-work">
      <h2 id="about-work">The person behind the work</h2>
      <p>
        John founded leadership.NET and LeaderBridge to examine how leadership intent is
        interpreted, clarified and carried into consequential action.
      </p>
      <p>
        His work focuses on human judgment, organizational reality and the structures that help
        people retain meaningful agency while working with others.
      </p>
      <nav className="about-page__links" aria-label="John Behr profiles and related work">
        <a href="https://www.linkedin.com/in/johnbehr" target="_blank" rel="noopener noreferrer">
          LinkedIn ↗
        </a>
        <a href="https://spaceas.com/about" target="_blank" rel="noopener noreferrer">
          SPACEAS ↗
        </a>
        <a href="https://leaderbridge.com/about-us" target="_blank" rel="noopener noreferrer">
          LeaderBridge ↗
        </a>
      </nav>
    </section>
  </article>
)

export default AboutPage
